import {
  ADD_DEPOT,
  EDIT_DEPOT,
  GROUP_ROUTES_BY_VALUE,
  groupingTypes,
  FETCH_START,
  FETCH_END,
  ABORT_FETCH,
  SET_DELIVERY_CATEGORY_TYPES,
  SET_DELIVERY_STATUS_TYPES,
  SET_LOAD_DIMENSION,
  SIDEBAR_TOGGLE,
  SET_SELECTED_PROCESS,
  SET_SELECTED_VERSION,
  SET_COMPANY,
  SET_WORKTIME_WINDOW,
  SET_DEPOTS,
  CHANGE_LANGUAGE,
  CHANGE_EXPORT_COLS,
  REMOVE_PROCESS,
  SET_PROCESS,
  TOGGLE_CORRECTION,
  SEEN_PROCESS,
  SET_INSTANCE,
  SET_USE_TERRITORIES, TOGGLE_LOADING, SET_SETTINGS,
  SET_PREFILLED_process_id,
  SET_RECENT_PLANNING_DATE,
  SET_OPTIMIZATION_DATA,
  SET_ACTIVE_COLS,
  SET_SHIPMENT_SETTINGS,
  UPDATE_TIME_WINDOW,
  SET_UI_FLAGS
} from '@/actions/types';
import { sortProcess } from '@/config/store/storeUtil';


/**
 *
 * This Common State is getting persisted into the localstorage, see the /config/store/storeUtil.js file to
 * see which parts getting persisted.
 */

const initialState = {
  loading: false,
  abort_fetch_reason: null,
  sidebar: true,
  language: 'de',
  companyAddress: {},
  timewindow_start: null,
  timewindow_end: null,
  ui: [],
  instance: {
    assets_source:'',
    customerurl:'',
    frontendurl:'',
    customername:'',
    firstname:'',
    lastname:'',
    email:'',
    companyname:'',
    activationcode:'',
    usertype:'',
    showPage:'',
  },
  depots: [],
  dimensions: [],
  delivery_status_types: [],
  delivery_category_types: [],
  use_territories: false,
  grouping: groupingTypes.VEHICLE,
  seenProcess: true,
  process: {},
  settings: [],
  selected_process: undefined,
  selected_version: null, // null = latest version of the selected optimization
  recent_planning_date : undefined,
  optimization_data:undefined,
  correction: {
    action: null,
    open: false
  },
  prefilledProcessId: '',
  activeCols: ['id', 'contactcompany', 'city', 'address', 'eta', 'load', 'duration', 'custom_tour', 'shipment_type'],
  pickup_time_window: { start: null, end: null },
  delivery_time_window: { start: null, end: null },
};

// CORE Loading State Reducer
export const commonReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_START:
    return {
      ...state,
      loading: true
    };
  case FETCH_END:
    return {
      ...state,
      loading: false
    };
  case TOGGLE_LOADING:
    return {
      ...state,
      loading: action.data
    };
  case SET_SELECTED_PROCESS:
    return {
      ...state,
      selected_process: action.data,
      // Picking a DIFFERENT plan resets the version back to "latest". Re-selecting
      // the current plan keeps the pinned version — otherwise the MFE remounts on
      // "latest" and discards its draft for the pinned version.
      selected_version:
        action.data?.optimization_id === state.selected_process?.optimization_id
          ? state.selected_version
          : null
    };
  case SET_SELECTED_VERSION:
    return {
      ...state,
      selected_version: action.data
    };
  case SET_USE_TERRITORIES:
    return {
      ...state,
      use_territories: action.data
    };
  case SEEN_PROCESS:
    return {
      ...state,
      seenProcess: action.value
    };
  case ABORT_FETCH:
    return Object.assign({}, state, {
      abort_fetch_reason: action.data
    });
  case SET_DELIVERY_CATEGORY_TYPES:
    return {
      ...state,
      delivery_category_types: action.data
    };
  case TOGGLE_CORRECTION:
    return {
      ...state,
      correction: {
        action: action.data.props,
        open: action.data.open
      }
    };
  case SET_DELIVERY_STATUS_TYPES:
    return {
      ...state,
      delivery_status_types: action.data
    };
  case SET_LOAD_DIMENSION:
    return {
      ...state,
      dimensions: action.data
    };
  case SIDEBAR_TOGGLE:
    return Object.assign({}, state, {
      sidebar: action.value
    });
  case SET_COMPANY:
    return Object.assign({}, state, {
      companyAddress: action.value
    });
  case SET_WORKTIME_WINDOW:
    return {
      ...state,
      timewindow_start: action.start,
      timewindow_end: action.end
    };
  case SET_DEPOTS:
    return {
      ...state,
      depots: [...action.data]
    };
  case SET_SETTINGS:
    return {
      ...state,
      settings: [...action.data]
    };
  case CHANGE_LANGUAGE:
    return Object.assign({}, state, {
      language: action.data
    });
  case CHANGE_EXPORT_COLS:
    return {
      ...state,
      exportCols: action.data
    };
  case GROUP_ROUTES_BY_VALUE:
    return {
      ...state,
      grouping: action.data
    };
  case EDIT_DEPOT:
    return {
      ...state,
      depots: [...state.depots].map(d => ((d.id === action.data.id) ? action.data : d))
    };
  case ADD_DEPOT:
    return {
      ...state,
      depots: [...state.depots, action.data]
    };
  case SET_INSTANCE:
    return {
      ...state,
      ui: action.data.frontend_flags,
      instance: action.data
    };
  case SET_PROCESS:
    return ({
      ...state,
      process: {
        ...state.process,
        [action.data.optimization_id]: action.data
      }
    });
  case REMOVE_PROCESS:
    // eslint-disable-next-line
    const { [action.data.toString()]: value, ...rest } = state.process;
    return ({
      ...state,
      process: sortProcess({
        ...rest
      }, 10)
    });
  case SET_PREFILLED_process_id:
    return {
      ...state,
      prefilledProcessId: action.data
    };
  case SET_RECENT_PLANNING_DATE:
    return {
      ...state,
      recent_planning_date: action.data
    };
  case SET_OPTIMIZATION_DATA:
    return {
      ...state,
      optimization_data: action.data
    };
  case SET_ACTIVE_COLS:
    return {
      ...state,
      activeCols: action.payload,
    };

  case SET_SHIPMENT_SETTINGS:
    return {
      ...state,
      shipmentSettings: action.payload
    };

  case UPDATE_TIME_WINDOW: {
    const { section, key, windowValue } = action.payload;
    return {
      ...state,
      shipmentSettings: {
        ...state.shipmentSettings,
        [section]: {
          ...state.shipmentSettings[section],
          [key]: windowValue
        }
      }
    };
  }
  case SET_UI_FLAGS:
    return {
      ...state,
      ui: action.data
    };
  default:
    return state;
  }
};